import React, { useState } from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { deleteSingleFirm } from '../../../Store/PHPSlice/Firm';


const TableBody = ({
    id,
    serialNumber,
    FirmName,
    email,
    contactNo,
    address,
    panNo,
    gstNo,
    accNo,
    bankName,
    branchName,
    ifscCode,
    website,
    image,
    selected,
    handleClick,
}) => {
    const imgUrl = process.env.REACT_APP_IMAGE_URL;

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const dispatch = useDispatch();
    // const getDelete = useSelector((state) => state.companyData.deleteComp);
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/FirmEdit/${id}`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };
    const handleDeleteClick = () => {
        // Show confirmation dialog
        const isConfirmed = window.confirm("Are you sure you want to delete this company?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            dispatch(deleteSingleFirm(id))
                .then(() => {
                    // Reload the page to show updated results
                    toast.success("Company Deleted Sucessfully");
                    window.location.reload();
                })
                .catch((error) => {
                    // Handle any errors that occur during the deletion process
                    console.error("Error deleting company:", error);
                    toast.error("Failed to delete company");
                });
        }
    };
    const baseUrl = process.env.REACT_APP_IMAGE_URL;
    const newImg = image.replace(/ /g, '%20');

    // Function to open the modal
    const openModal = (imageUrl) => {
        // const url = `http://localhost:8081/demoApi/${imageUrl}`;
        const url = `${imgUrl}/${imageUrl}`;
        setSelectedImage(url);
        setIsModalOpen(true);
    };

    // Function to close the modal
    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedImage(null);
    };
    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {serialNumber}
                </TableCell>

                <TableCell component="th" scope="row"
                    sx={{ p: 1, border: '1px solid #000' }} align='center'>

                    <Typography variant="subtitle2" noWrap>
                        {FirmName}
                    </Typography>

                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {email}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {contactNo}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {address}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {panNo}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {gstNo}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {accNo}
                </TableCell>


                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {bankName}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {branchName}
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {ifscCode}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {/* {image} */}
                    {image === 'noImage' ? image :
                        <img
                            // src={`http://localhost:8081/demoApi/${newImg}`}
                            src={`${imgUrl}/${newImg}`}
                            style={{ width: '8vw', height: '10vh', margin: '0.5vw', cursor: 'pointer' }}
                            alt="Item Thumbnail"
                            onClick={() => openModal(newImg)}
                        />
                    }
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    {website}
                </TableCell>
                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <EditIcon className="cursor-pointer" onClick={handleEditClick} />
                </TableCell>

                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className="cursor-pointer" onClick={handleDeleteClick} />
                </TableCell>
            </TableRow>
            <ToastContainer />

            {isModalOpen && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <span className="modal-close" onClick={closeModal}>X</span>
                        <img src={selectedImage} style={{ maxWidth: '90vw', maxHeight: '90vh', objectFit: 'contain' }} alt="Large View" />
                    </div>
                </div>
            )}
        </>
    );
};

export default TableBody;
